export const columns = function () {
    return [
		{
		    prop: 'insBillId',
		    label: '流水号',
		    minWidth: 100
		},
		{
		    prop: 'bh',
		    label: '单号',
		    minWidth: 150
		},
		{
		    prop: 'carNo',
		    label: '车牌号',
		    minWidth: 100
		},
		{
		    prop: 'status',
		    label: '状态',
		    minWidth: 100,
			render: ({ status }) => {
			    return (this.$emun.status.find(item => item.value === status)).label || '-'
			}
		},
		{
		    prop: 'personName',
		    label: '被服人',
		    minWidth: 150
		},
		{
		    prop: 'customerFee',
		    label: '应交费用（元）',
			sortable: true,
		    minWidth: 150
		},
		{
		    prop: 'beginTime',
		    label: '服务起期',
			sortable: true,
		    minWidth: 150
		},
		{
		    prop: 'endTime',
		    label: '服务止期',
			sortable: true,
		    minWidth: 150
		},
        {
            prop: 'orgName',
            label: '出单机构',
            minWidth: 150
        },
		{
		    prop: 'saleName',
		    label: '业务员',
		    minWidth: 100
		},
		{
		    prop: 'CreatorName',
		    label: '制单员',
		    minWidth: 100
		},
		{
		    prop: 'auditName',
		    label: '审核人',
		    minWidth: 100
		},
		{
		    prop: 'HandlerName',
		    label: '经办人',
		    minWidth: 100
		},
		{
		    prop: 'create_time',
		    label: '提交时间',
			sortable: true,
		    minWidth: 150
		},
		{
		    prop: 'auditTime',
		    label: '审核时间',
			sortable: true,
		    minWidth: 150
		},
		{
		    prop: 'payTime',
		    label: '交费时间',
			sortable: true,
		    minWidth: 150
		},
    ]
}

export default {}